module.exports = __webpack_public_path__ + "static/media/team.ec6f73db.jpeg";